import { Icon, IconProps } from '@chakra-ui/react';
import * as React from 'react';

export const VideoMeetIcon: React.FC<IconProps> = (props) => (
  <Icon
    width="1.2em"
    height="1.2em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M15 10l4.553-2.276A1 1 0 0 1 21 8.618v6.764a1 1 0 0 1-1.447.894L15 14v-4z"></path>
    <rect x="3" y="5" width="12" height="14" rx="2" ry="2"></rect>
    <path d="M7 9v6"></path>
    <path d="M11 9v6"></path>
  </Icon>
);
